import React, { useState, useEffect } from 'react';
import { getLeaderboard } from '../services/api';

const ARCHETYPE_COLORS = ['#00d4ff', '#a78bfa', '#f59e0b', '#10b981', '#ef4444', '#f97316'];

export default function EmbedLeaderboard() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const params = new URLSearchParams(window.location.search);
  const genre = params.get('genre') || 'all';
  const sortBy = params.get('sortBy') || 'overallScore';

  useEffect(() => {
    getLeaderboard({ limit: 10, sortBy, genre })
      .then(({ entries: e }) => setEntries(e || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [genre, sortBy]);

  return (
    <div style={{
      background: '#0a0f1e',
      padding: 16,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      minHeight: '100vh',
      color: '#f8fafc',
    }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#00d4ff', marginBottom: 12, letterSpacing: 1 }}>
        NeuroRank Top 10
      </div>

      {loading ? (
        <div style={{ fontSize: 13, color: '#475569' }}>Loading...</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {entries.map((entry, i) => {
              const archetypeColor = ARCHETYPE_COLORS[i % ARCHETYPE_COLORS.length];
              const score = entry.scores?.overallScore
                ?? Math.round(
                  Object.entries(entry.scores || {})
                    .filter(([k]) => k !== 'overallScore')
                    .reduce((a, [, v]) => a + v, 0) /
                  Math.max(Object.keys(entry.scores || {}).filter(k => k !== 'overallScore').length, 1)
                );

              return (
                <tr key={entry.shareableId} style={{ borderBottom: '1px solid #1f2d3d' }}>
                  <td style={{ padding: '8px 6px 8px 0', width: 24, fontSize: 12, color: '#475569', fontWeight: 700 }}>
                    {i + 1}
                  </td>
                  <td style={{ padding: '8px 6px', fontSize: 13, color: '#f8fafc', fontWeight: 600 }}>
                    {entry.playerTag}
                  </td>
                  <td style={{ padding: '8px 6px', fontSize: 12, color: archetypeColor }}>
                    {entry.archetype?.name || '—'}
                  </td>
                  <td style={{ padding: '8px 0 8px 6px', fontSize: 13, fontWeight: 700, color: '#00d4ff', textAlign: 'right' }}>
                    {score}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <div style={{ marginTop: 12, textAlign: 'right' }}>
        <a
          href="https://neurorank.app/leaderboard"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 11, color: '#475569', textDecoration: 'none' }}
        >
          View Full Leaderboard →
        </a>
      </div>
    </div>
  );
}
